/* YOUR MOTION — wishlist page empty state + live removal.
   <stored-products> (theme.js) renders cards and hides [data-stored-wrapper]
   when there is nothing to show (dispatching a bubbling `stored:empty`).
   This module shows the empty state in every case: on that event, when the
   wrapper was already hidden before we loaded, and when the last card is removed. */
if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-stored-wrapper]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.list = this.querySelector('[data-stored-list]');
      this.status = this.querySelector('[data-wishlist-status]');

      this.onEmpty = () => this.showEmpty();
      this.onUpdate = (e) => this.handleUpdate(e.detail || {});
      this.addEventListener('stored:empty', this.onEmpty);
      document.addEventListener('wishlist:updated', this.onUpdate);

      // Wrapper may already be hidden (stored-products ran before this module)
      if (this.wrapper?.hidden) this.showEmpty();

      // Watch for the wrapper being hidden later (e.g. every card failed to load)
      // and for cards arriving (to clear the busy state).
      this.observer = new MutationObserver(() => this.sync());
      if (this.wrapper) this.observer.observe(this.wrapper, { attributes: true, attributeFilter: ['hidden'] });
      if (this.list) this.observer.observe(this.list, { childList: true });
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:updated', this.onUpdate);
      this.observer?.disconnect();
    }

    sync() {
      if (this.wrapper?.hidden) { this.showEmpty(); return; }
      const cards = this.list ? this.list.querySelectorAll('[data-product-card]').length : 0;
      if (cards) {
        this.list.removeAttribute('aria-busy');
        this.announce(cards);
      }
    }

    handleUpdate({ handle, added }) {
      if (added !== false || !handle || !this.list) return;
      this.list.querySelectorAll('[data-handle]').forEach((card) => {
        if (card.dataset.handle === handle) (card.closest('li') || card).remove();
      });
      const remaining = this.list.querySelectorAll('[data-product-card]').length;
      if (!remaining) {
        if (this.wrapper) this.wrapper.hidden = true;
        this.showEmpty();
      } else {
        this.announce(remaining);
      }
    }

    announce(count) {
      if (!this.status) return;
      const tpl = count === 1 ? this.status.dataset.countOne : this.status.dataset.countOther;
      if (tpl) this.status.textContent = tpl.replace('[count]', count);
    }

    showEmpty() {
      if (!this.empty || !this.empty.hidden) return;
      this.list?.removeAttribute('aria-busy');
      this.empty.hidden = false;
      if (this.status) this.status.textContent = '';
      window.SIM?.initReveal?.(this.empty);
    }
  }
  customElements.define('wishlist-page', WishlistPage);
}
